import { Platform } from '@/types/platform'
import { Mutation } from 'vuex'
import { RootState } from '../types'

const setPlatform: Mutation<RootState> = (state, payload: Platform) => {
  state.platform = payload
}

export default setPlatform
